<template>
  <div>
    <Header
      title="Consultar Alocações"
      subtitle="Consulte, renomeie ou remova alocações geradas anteriormente."
    />
    <div class="plans-content">
      <Loading v-if="loading_data" />
      <HandleDisplayPlans
        v-else
        :plans="PlanList"
        :demo="demoMode"
      />
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import HandleDisplayPlans from "@/handles/paas/plan/HandleDisplayPlans.vue";
import Loading from "@/components/Loading.vue";

import { getPaasPlans, thereArePlansInQueue } from "@/api/paas/plans";
import { getPaasPlansDemo } from "@/fixtures/paasPlansDemo";

export default {
  name: "PaasHistorico",
  components: {
    Header,
    HandleDisplayPlans,
    Loading
  },
  created() {
    this.$store.commit("setCurrentComponent", {
      component: "Paas"
    });
  },
  data: () => ({
    loading_data: false,
    PlanList: []
  }),
  computed: {
    demoMode() {
      return this.$route.query.demo == "1";
    }
  },
  methods: {
    updatePlanList() {
      if (this.demoMode) {
        this.PlanList = getPaasPlansDemo();
        this.loading_data = false;
        return;
      }

      // get array of plans in database through db api
      this.loading_data = true;
      getPaasPlans()
        .then(_ => {
          this.PlanList = _;
        })
        .finally(() => {
          this.loading_data = false;
        });
    },
    verifyIfthereArePlansInQueue(firstRun = true) {
      if (this.demoMode) return;

      thereArePlansInQueue()
        .then(_ => {
          if (_) {
            setTimeout(
              this.verifyIfthereArePlansInQueue,
              3000,
              false
            );
            return;
          }
          if (!firstRun) {
            this.updatePlanList();
            return;
          }
        })
        .catch(() => {
          console.log("erro ao verificar planos em fila");
        });
    }
  },
  mounted() {
    //Update PlanList
    this.updatePlanList();
    this.verifyIfthereArePlansInQueue();
  }
};
</script>

<style scoped>
.plans-content {
  padding-top: 32px;
}
</style>
